module.exports = __webpack_public_path__ + "img/background-image.162da292.png";